import { createSelector } from '@ngrx/store'

export const getGisSettingsState = createSelector(
  (state: any) => state.gisSettings,
  (state: any) => state,
)
